import normalize from 'json-api-normalize';
import { AddressModel } from './address.model';
import { DrupalBaseModel } from './drupal-base.model';

export class IndividualModel extends DrupalBaseModel {

  public static parseIndividual(individualJson: any): IndividualModel {
    const normalizedData = normalize(individualJson).get([
      'field_first_name',
      'field_middle_name',
      'field_last_name',
      'field_degrees',
      'field_phone',
      'field_phone_ext',
      'field_fax',
      'field_email',
      'parent_field_name',
      'field_address',
      'id',
      'field_suffix',
      'drupal_internal__revision_id'
    ]);

    return new IndividualModel({
      first_name: normalizedData.field_first_name,
      middle_name: normalizedData.field_middle_name,
      last_name: normalizedData.field_last_name,
      degree: normalizedData.field_degrees,
      phone: normalizedData.field_phone,
      phone_ext: normalizedData.field_phone_ext,
      fax: normalizedData.field_fax,
      email: normalizedData.field_email,
      type: normalizedData.parent_field_name,
      address: normalizedData.field_address
        ? new AddressModel({
          organization: normalizedData.field_address.organization,
          address1: normalizedData.field_address.address_line1,
          address2: normalizedData.field_address.address_line2,
          city: normalizedData.field_address.locality,
          state: normalizedData.field_address.administrative_area,
          zipCode: normalizedData.field_address.postal_code,
          countryCode: normalizedData.field_address.country_code,
        })
        : new AddressModel(),
      uuid: normalizedData.id,
      suffix: normalizedData.field_suffix,
      revision_id: normalizedData.drupal_internal__revision_id
    });

  }

  public first_name = '';
  public middle_name = '';
  public last_name = '';
  public degree = '';
  public phone = '';
  public phone_ext = '';
  public fax = '';
  public email = '';
  public type = '';
  public suffix = '';
  public revision_id = '';

  public address: AddressModel;

  constructor(values?: Partial<IndividualModel>) {
    super(values);

    Object.assign(this, values);
  }
}
